core.factory("coreLanguage", ()=>{return{
    //Titles
    appName: "Example",
    signIn: "Crie uma conta",
    login: "Entrar",
    loginWithLink: "Link de Login",
    passwordRecover: "Recuperar Senha",
    resendFirstAccess: "Reenvio de 1º acesso",
    resetPass: "Defina a sua senha de acesso",
    loginWithEmail: "Entre com seu email",
    dontHaveAccount: "Não tem uma conta?",
    haveAccount: "Já possui uma conta?",
    rememberDevice: "Salvar sessão",
    selected: "selecionados",
    details: "Detalhes",

    menu:{
        dashboard: "Dashboard",
        home: "Início",
        account: "Minha conta",
        settings: "Opções",
        customers: "Clientes",
        users: "Usuários",
        sales: "Vendas",
        products: "Produtos",
        notices: "Avisos",
        membersArea: "Área de membros",
        reports: "Relatórios",
        faq: "F.A.Q",
        classes: "Cursos"
    },
    menuClient:{
        guides: "Guia",
        community: "Comunidade",
        partners: "Partners",
        help: "Ajuda",
        support: "Suporte",
        accelerator: "Acelerador"
    },
    account:{
        myProfile: "Meus dados",
        address: "Endereço",
        myBilling: "Faturas"
    },
    passRequires:{
        minChars:"8 caracteres",
        number: "1 Número",
        upperCase: "1 Letra maiúscula",
        specialChar: "1 Caractere especial"
    },
    indicators:{
        startedSendings: "Envios iniciados",
        endedSendings: "Envios Finalizados",
        newContacts: "Novos contatos",
        connectedChannels: "Canais conectados"
    },
    models: "Modelos",

    ///Labels and Placeholders
    whatsapp: "Whatsapp",
    email: "Email",
    password: "Senha",
    fullName: "Nome completo",
    name: "Nome",
    phone: "Telefone / Whatsapp",
    taxNumber: "CPF",
    payerTax: "CPF da compra",
    birthDate: "Data de nascimento",
    postalCode: "CEP",
    address1: "Logradouro",
    address2: "Bairro",
    address3: "Complemento",
    addressNumber: "Nº",
    city: "Cidade",
    province: "UF",
    personalData: "Dados pessoais",
    accessData: "Dados de acesso",
    passConfirm: "Confirmar Senha",
    actions: "Ações",
    search: "Buscar...",
    currency: "R$",
    businessHours: "Horário de funcionamento",
    day: "Dia",
    start: "Início",
    end: "Fim",
    token: "Token",
    active: "Ativo",
    inactive: "Inativo",
    platform: "Plataforma",
    webhookUrl: "URL do Webhook",
    regDate: "Data cadastro",
    publiDate: "Data publicação",
    connected: "Conectado",
    disconnected: "Desconectado",
    customers: "Leads",
    timeTyping: "Tempo digitando (seg.)",
    timeRecording: "Tempo gravando (seg.)",
    readLastMessage: "Ler última mensagem do contato",
    waitMessage: "Aguardar resposta",
    wait: "Aguardar",
    destiny: "Destino",
    rule: "Regra",
    promptText: "Texto do prompt ...",
    writeText: "Texto da mensagem ...",
    event: "Evento",
    if: "Se",
    else: "Se não",
    notProvided: "Não previsto",
    intents: "Intenções",
    basics: "Básicos",
    waitUntil: "Sem resposta após",
    changeWhatsapp: "Alterar whatsapp",
    linkedInstance: "Whatsapp vinculado",
    versions: "Versões",
    restore: "Restaurar",
    actualVersion: "Versão recente",
    sendings: "Envios",
    leadsIn: "Envios iniciados",
    leadsInStep: "Envios nessa etapa",
    interval: "Intervalo",
    today: "Hoje",
    weekly: "7 dias",
    monthly: "30 dias",
    all: "Todos",
    profile: "Perfil",
    change: "Alterar",
    changePass: "Alterar senha",
    emptyData: "Não informado",
    customerHelp: "Atendimento ao cliente",
    certified: "Certificado",
    content: "Conteúdos",
    general: "Geral",
    myProgress: "Meu Progresso",
    answer: "Leia a explicação",
    course: "Curso",
    module: "Módulo",
    askSomething: "Pergunte algo sobre o curso",
    levels: "Níveis",
    destiny:"Destino",
    description: "Descrição",
    image: "Imagem",
    subtitle:"Subtítulo",
    title: "Título",
    articles: "Artigos",
    order: "Ordem",
    session: "Sessão",
    moduleType: "Tipo de módulo",
    lessonType: "Tipo de aula",
    unlockAfter: "Liberar após (dias)",
    videoType: "Tipo",
    data: "Dados",
    file: "Arquivo",
    files: "Arquivos",
    fileName: "Nome do arquivo",
    question: "Questão",
    options: "Opções",
    communityLink: "Link da comunidade",
    btnLabel: "CTA Botão",
    accessLevel: "Nível de acesso",

    ///Links and Buttons
    forgotPassword: "Esqueceu a senha?",
    back: "Voltar",
    next: "Próxima",
    close: "Fechar",
    sendAccess: "Enviar acesso",
    sendLink: "Enviar Link",
    sendRecoverLink: "Enviar link de recuperação",
    sendAccessEmail: "Reenviar dados de 1º acesso",
    tryAgain: "Tentar de novo",
    logout: "Sair",
    save: "Salvar",
    cancel: "Cancelar",
    register: "Cadastrar",
    delete: "Excluir",
    block: "Bloquear",
    bulkSend: "Envio em massa",
    download: "Download",
    color: "Cor",
    yes: "Sim",
    no: "Não",
    copy: "Copiar",
    edit: "Editar",
    add: "Adicionar",
    lessons: "Aulas",
    activate: 'Ativar',

    perPage: "por página",
    addContact:"Add Contato",
    addWhatsapp:"Add Whatsapp",
    editWhatsapp:"Editar Whatsapp",
    addFlow: "Add Fluxo",
    editFlow: "Editar Fluxo",
    deleteReg: "Excluir registro",
    importContacts: "Importar contatos",
    addAccess: "Add acesso",
    addUser: "Add Usuário",
    editUser: "Editar usuário",
    product: "Produto",
    addProduct: "Add produto",
    editProduct: "Editar produto",
    addNotice: "Add aviso",
    editNotice: "Edit aviso",

    departments: "Setores",
    department: "Setor",
    addDepartment: "Add Setor",
    editDepartment: "Editar Setor",
    
    tags: "Tags",
    tag: "Tag",
    addTag: "Add Tag",
    editTag: "Editar Tag",
    
    integrations: "Integrações",
    addIntegration: "Add Integração",
    editIntegration: "Editar Integração",
    inIntegrations: "Integrações (Entrada)",
    outIntegrations: "Integrações (Saída)",
    reactTo: "Reagir",

    disconnect: "Desconectar",
    connecting: "Conectando",

    clean: "Limpar",
    stop: "Parar",
    restart: "Reiniciar",
    flowItems: "Items do fluxo",
    flowStart: "Início do fluxo",
    saveAsModel: "Salvar como modelo",
    deleteModel: "Excluir modelo",

    myCourses: "Cursos disponíveis",
    concluded: "módulos concluídos",
    sendAnswers: "Enviar respostas",
    clickToRead: "Toque para ler",

    positioning: "Posicionamento",
    alignment: "Alinhamento",
    textStyle: "Estilo do Texto",
    lineBase: "Base da Linha",
    crossSell: "Cross sell",

    ///Info and Helpers
    notStarted: "Não iniciou",
    startedAt: "Iniciou em ",
    alreadyAdded: "Registro já adicionado",
    incompatibleResource: "Este navegador não é compatível com esta funcionalidade.",
    infoLoginLink: "Você receberá uma mensagem por email contendo um link de login.",
    infoRecoverLink: "Enviaremos um email com o link para que você possa alterar a sua senha.",
    infoResend: "Você receberá a mensagem com os dados de acesso padrão. Caso você já tenha alterado sua senha antes utilize uma das opções ",
    infoReset: "Este é o seu primeiro acesso, defina a senha que será utilizada para realizar login na ferramenta.",
    sentLoginLink: "Enviamos para seu email um link para que você consiga fazer login. IMPORTANTE: Verifique na caixa de spam do seu email.",
    sentRecoverLink: "Enviamos para seu email um link para que você possa definir uma nova senha e acessar sua conta. IMPORTANTE: Verifique na caixa de spam do seu email.",
    sentAccesEmail: "Enviamos para seu email os dados de 1º acesso. IMPORTANTE: Verifique na caixa de spam do seu email.",
    successfullUpdate: "Alteração realizada!",
    agreementText: "Ao se cadastrar no sistema você está de acordo com os",
    usageTerms: "Termos de uso",
    policyTerms: "Políticas de privacidade",
    emptyRegistry: "Nenhum registro encontrado",
    emptyCertificate: "Ainda não possui certificados",
    pressSelect: "Clique para selecionar",
    confirmDeletion: "Confirma a exclusão do registro?",
    confirmDisconnect: "Deseja desconectar as instâncias selecionadas?",
    confirmRestart: "Deseja reiniciar os envios dos fluxos selecionados?",
    confirmStop: "Deseja parar os envios dos fluxos selecionados?",
    confirmExitSave: "Deseja salvar as alterações antes de sair?",
    fileUpload: "Arraste ou clique para fazer o upload",
    infoAiGenerator: "Utilize I.A. para gerar uma resposta em texto para o contato. Quanto mais específico o prompt mais assertiva será a resposta gerada.",
    infoAiDecider: "Informe quais intenções nossa I.A. deve identificar e decidir com base na maior correspondência com a última mensagem do contato",
    testSent: "Mensagem de teste enviada com sucesso!",
    testMsg: "Olá, esta é uma mensagem de teste! O whatsapp está conectado.",
    sendTest: "Testar",
    startedPercent: "dos iniciados",
    higher: "de aumento",
    lower: "de queda",
    chooseCourse: "Escolha o curso que deseja estudar.",
    updateSuccess: "Atualizado com sucesso!",

    ///Errors
    somethingWrong: "Oops, há algo de errado.",
    resourceNotFound: "O recurso solicitado não foi encontrado.",
    resourceNotEnabled: "Os recursos não estão disponíveis.",
    formGenError: "Os dados informados não são válidos. Verifique e tente novamente.",
    errNoAccount:"Ops! Você tem uma conta? Confira se o email está correto.",
    wrongPass:"Ops! Parece que algo está errado, verifique sua senha.",
    blockedAccount:"Sua conta está desativada! Por favor, entre em contato.",
    temporaryBlockedAccount:"Bloqueada por excesso de tentativas, redefina a senha ou aguarde alguns minutos.",
    emailAlreadyExists: "Email já cadastrado, faça login",
    errFileRead: "Erro ao ler o arquivo.",
    errFileFormat: "Formato de arquivo inválido.",
    errImport: "Erro ao tentar realizar a importação.",
    successImport: "Importação realizada com sucesso.",

    ///Errors - required fields
    requiredEmail: "Informe seu email",
    requiredPassword: "Informe sua senha",
    requiredPassConfirm: "Obrigatório confirmar a senha",
    requiredName: "Informe o seu nome completo",
    requiredPhone: "Obrigatório informar telefone/whatsapp",
    requiredTaxNumber: "Obrigatório informar o CPF",
    requiredBirthDate: "Obrigatório informar o nascimento",
    requiredPostalCode: "O código postal informado é inválido",
    requiredAgreement: "Necessário aceitar os termos de uso para continuar",
    requiredField: "O Preenchimento do campo é obrigatório",
    passwordRequirement: "A senha precisa conter",

    ///Mask and Formats
    maskPhone: "(99) 9999?9-9999",
    maskTaxNumber:"999.999.999-99",
    maskPostalCode: "99999-999",

    weekDays: [
        "Domingo",
        "Segunda",
        "Terça",
        "Quarta",
        "Quinta",
        "Sexta",
        "Sábado"
    ],
    timeOptions:[
        { value: "seconds", label: "Segundos" },
        { value: "minutes", label: "Minutos"},
        { value: "days", label: "Dias" }
    ],
    transferOptions:[
        {value: "agent", label: "Agente"},
        //{value: "step", label: "Etapa"},
        {value: "flow", label: "Fluxo"}
    ],
    tagOptions:[
        {value: "add", label: "Adicionar"},
        {value: "remove", label: "Remover"}
    ],
    targetOptions:[
        { value: '_blank', label: 'Nova Aba' },
        { value: '_self', label: 'Mesma Aba' }
    ],
    contentOptions:[
        { value: 'video', label: 'Vídeo', icon: 'ph-video-camera' },
        { value: 'text', label: 'Texto', icon: 'ph-text-align-left' },
        { value: 'files', label: 'Arquivos', icon: 'ph-file-arrow-up' },
    ]

}});